import { AdminComponent } from '~/components/admin-component/admin-component';

export const CallActions = () => (
  <AdminComponent
    componentName="CallLogActions"
    title="Call Log Actions"
  />
);
